import { useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useGetTeam } from '@entities/myTeam/lib/hooks';

export const useAssignTaskToEmployee = (currentClickedId: number) => {
    const { t } = useTranslation();
    const [triggerAnimationError, setTriggerAnimationError] = useState(false);
    const {
        data: { employees },
    } = useGetTeam();

    const executorId = useMemo(
        () => employees?.find((item) => item.id === currentClickedId)?.id?.toString(),
        [employees, currentClickedId]
    );

    return {
        t,
        setTriggerAnimationError,
        triggerAnimationError,
        employees,
        executorId,
    };
};
